<header mat-dialog-title>
    <div class="dialog-header">
      <h2 class="mat-h2">Crear evento</h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
</header>
<mat-dialog-content class="modal-central-container">
    <form class="cm-">
        <mat-form-field [class]="'full-width'" appearance="outline">
            <mat-label>Tipo de evento</mat-label>
            <mat-select placeholder="Tipo de evento" [formControl]="tipoEvento">
                <mat-optgroup *ngFor="let tipoEvento of tiposEvento" [label]="tipoEvento.nombre">
                    <mat-option *ngFor="let categoria of tipoEvento.categorias" [value]="categoria.id">
                        {{categoria.nombre}}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
            <mat-error *ngIf="tipoEvento.hasError('required')">El tipo de evento es obligatorio.
            </mat-error>
        </mat-form-field>
        <mat-form-field [class]="'full-width'" appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput placeholder="Título" [formControl]="nombreEvento">
        </mat-form-field>
        <div class="toolsField">
            <mat-label>Descripción</mat-label>
            <div class="enunciado-ck-container">
                <!-- <ckeditor appCkeditorImageDelete name="descripcion" [formControl]="resumenForm"
                    [editor]="inlineEditor"
                    [config]="{language: 'es', url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken, origen: 'Unidad', store: 'Estudio'}">
                </ckeditor> -->
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions style="display: flex;">
    <button mat-button mat-dialog-close [disabled]="saving">Cancelar</button>
    <!-- <div class="spacer"></div> -->
    <button mat-button color="primary" [disabled]="saving" (click)="guardar()">Guardar y cerrar</button>
    <button mat-raised-button color="primary" [disabled]="saving" (click)="guardar(true)">Guardar y editar</button>
</mat-dialog-actions>
